import React from 'react';

export default class MarqueeTitle extends React.Component {
	renderMarquee = () => {
		const Container = this.props.play ? 'marquee' : 'div';

		return (
			<Container
				className="gecko-tape-recorder__player-title"
				direction={this.props.direction || 'left'}
			>
				{this.props.title}
			</Container>
		)
	}
	render() {
		return this.renderMarquee();
	}
}